import styled from 'vue-styled-components';

const theme = { fontSize15: Number};

const ThemedLine = styled('div', theme)`
    display: flex;
    align-items: center;
    font-size: ${props => props.fontSize15}px;
    margin-bottom: 4px;
`;

export default ThemedLine
